import { useNavigate } from 'react-router-dom';
import HataSayfasi, { HataButon } from './HataSayfasi';
import { IkonUyari } from '../../components/Ikonlar';

export default function Page500() {
  const navigate = useNavigate();

  return (
    <HataSayfasi
      kod="500"
      renk="rose"
      ikon={<IkonUyari size={40} />}
      baslik="Sunucu Hatası"
      aciklama={<>İşlem sırasında beklenmeyen bir hata oluştu. Kayıtlarınız korunuyor; birazdan tekrar deneyin.</>}
      altYazi="Hata sunucu günlüğüne bir referans numarasıyla yazılır. Sorun sürerse bu ekranı gördüğünüz saati ve yaptığınız işlemi bize iletin."
      aksiyonlar={
        <>
          <HataButon onClick={() => window.location.reload()}>Tekrar Dene</HataButon>
          <HataButon birincil onClick={() => navigate('/')}>Ana Sayfa</HataButon>
        </>
      }
    />
  );
}
